import React, { useCallback } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import DataComponentTablePaymentAccounts from "./DataComponent__TablePaymentAccounts";

const DataComponentBodyPaymentAccounts = ({
    data: propData,
    headerNames: propHeaderNames,
    multiLevelHeaderNames: propMultiLevelHeaderNames,
    columnData: propColumnData,
    loading: propLoading,
    settings: propSettings,
    settingKey: propSettingKey,
    filters: propFilters,
    className: propClassName,
    displayControl: propDisplayControl
}) => {
    const getRenderComponent = useCallback(() => {
        const data = propDisplayControl.data.find(item => item.type === propDisplayControl.type);
        const Component = data.component;

        if (React.isValidElement(Component)) {
            return Component;
        } else {
            return (
                <Component
                    data={propData}
                />
            );
        }
    }, [propDisplayControl, propData]);

    const renderTable = useCallback(() => {
        return (
            <DataComponentTablePaymentAccounts
                data={propData}
                headerNames={propHeaderNames}
                multiLevelHeaderNames={propMultiLevelHeaderNames}
                columnData={propColumnData}
                loading={propLoading}
                settings={propSettings}
                settingKey={propSettingKey}
                filters={propFilters}
                className={propClassName}
            />
        );
    }, [propData, propHeaderNames, propMultiLevelHeaderNames, propColumnData, propLoading, propSettings, propSettingKey, propFilters, propClassName]);

    return (
        propDisplayControl
            ? !propDisplayControl.type || propDisplayControl.type === 'table'
                ? renderTable()
                : getRenderComponent()
            : renderTable()
    );
};

DataComponentBodyPaymentAccounts.propTypes = {
    data: PropTypes.array,
    headerNames: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.object,
    loading: PropTypes.bool,
    settings: PropTypes.bool,
    settingKey: PropTypes.string,
    filters: PropTypes.object,
    className: PropTypes.string,
    displayControl: PropTypes.object
};

DataComponentBodyPaymentAccounts.defaultProps = {
    data: [],
    headerNames: [],
    multiLevelHeaderNames: [],
    columnData: {},
    loading: false,
    settings: false,
    settingKey: '',
    filters: {},
    className: '',
    displayControl: null
};

export default withTranslation(DataComponentBodyPaymentAccounts);
